<template>
    <div class="box">
        <Header></Header>

        <section>
            <img style="width: 100%;height: 150px;" :src="banner.path" alt="">
            <div class="nav" style="padding: 0 10px;margin-top: 10px;">
                <p style="border-left: 3px solid #BB1E10;padding-left: 10px;font-size: 17px;color: #333333;font-weight: bold;">{{typefaces == 1 ? '行业资讯' : 'Industry News'}}</p>
                <div style="border-bottom:1px solid #E7E7E7;padding-bottom:20px;" v-for="(item, index) in listData" :key="index" @click="jump(2, item.id)">
                    <p style="color:#BB1E10;font-size:15px;padding-top:20px;font-weight:bold;">{{item.releaseTime}}</p>
                    <p style="color:#121212;font-size:15px;padding-top:10px;font-weight:bold;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1; -webkit-box-orient: vertical;">{{typefaces == 1 ? item.name : item.nameEng}}</p>
                    <p style="color:#585858;font-size:14px;padding-top:10px;text-decoration: none;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2; -webkit-box-orient: vertical;">{{typefaces == 1 ? item.text : item.textEng}}</p>
                </div>
            </div>

          <Footer :typeFaces="typeFacesNumber" ></Footer>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';

export default {
	name: 'IndustryNews',
	components: {
		Header,
        Footer
	},
  computed: {
    aaa() {
      return this.$root.TYPEFACE;
    }
  },
  watch:{
    aaa(type) {
      this.typefaces = type;
    },
  },
	data () {
		return {
      typefaces: 1,
      typeFacesNumber: 0,
            banner: {},
            listData: []
		}
	},

	mounted() {
    this.typefaces = (this.$root.TYPEFACE == undefined ? this.typefaces : this.$root.TYPEFACE);
        this.getData();
        this.getList();
	},

	methods: {
    fatherMethod(type){
      this.typefaces = type;
      this.typeFacesNumber = type;
    },
        // 获取轮播图
		getData() {
			axios({
				url: this.url + '/content/input/fileList',
				method: 'post',
				data: {
					parentId: 0,
                    type: 15
				},
			}).then( res => {
                this.banner = res.data[0][0];
			});
		},

        // 获取列表
        getList() {
            axios({
				url: this.url + '/content/input/list?parentId=0&type=7&pageSize=20&pageNum=1',
				method: 'GET',
				data: {
				},
			}).then( res => {
                this.listData = res.data.rows;
			});
        },

        // 跳转详情页
        jump(text, id) {
            this.$router.push({path:'/Details', name:'Details', query:{text:text,id:id}});
        }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}
p, span, ul, li{
    margin: 0;
    padding: 0;
}
.box {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
}

section {
    flex: 1;
    overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/IndustryNews.vue